<template>
  <div id="app">
    <AstronautsPage />
  </div>
</template>

<script>
import AstronautsPage from './components/AstronautsPage.vue'

export default {
  name: 'app',
  components: {
    AstronautsPage
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
